import { render, staticRenderFns } from "./TeacherSubject.vue?vue&type=template&id=f9ce6da2&"
import script from "./TeacherSubject.vue?vue&type=script&lang=js&"
export * from "./TeacherSubject.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSubject.vue?vue&type=style&index=0&id=f9ce6da2&prod&lang=css&"
import style1 from "./TeacherSubject.vue?vue&type=style&index=1&id=f9ce6da2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports